/**
 * Copyright 2019 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { type Middleware as ReduxMiddleware } from 'redux';

type ActionLogger = {
  size: number;
  buffer: unknown[];
  currentIndex: number;
  printLIFO: () => unknown[];
  log: () => ReduxMiddleware;
};

type ActionLoggerConstructor = {
  new (size: number): ActionLogger;
};

function circularActionBuffer(this: ActionLogger, size: number) {
  this.size = size;
  this.buffer = new Array(size);
  this.currentIndex = -1;
}

(circularActionBuffer.prototype as ActionLogger).printLIFO = function () {
  const list = [];
  let curIndex = this.currentIndex;

  for (let i = 0; i < this.size; i++) {
    const action = this.buffer[curIndex];
    if (action) {
      list.push(action);
    }
    curIndex = (curIndex - 1) % this.size;
  }

  return list;
};

(circularActionBuffer.prototype as ActionLogger).log = function () {
  return () => (next) => (action) => {
    this.currentIndex = (this.currentIndex + 1) % this.size;
    this.buffer[this.currentIndex] = action;
    next(action);
  };
};

export const actionLogger = new (circularActionBuffer as unknown as ActionLoggerConstructor)(4);
